// import React, { useEffect, useState } from "react";
// import { Modal, FormGroup, Label, Button, Col, Row, Card } from "reactstrap";
// import { Link } from "react-router-dom";
// import Dropzone from "react-dropzone";
// import toast from "react-hot-toast";
// import DocumentServices from "../../../services/COOPServices/DocumentServices";
// import { useFormik } from "formik";
// import CustomInput from "../../../Components/Common/CustomInput/CustomInput";
// import axios from "axios";
// import Select from "react-select";

// const EditDocument = ({ isOpen, toggle, documentId, fetchData }) => {
//   const [selectedFiles, setSelectedFiles] = useState([]);
//   const [categoryId, setCategoryId] = useState([]);
//   const [selectedOption, setSelectedOption] = useState(null);

//   const userString = localStorage.getItem("user");
//   const user = JSON.parse(userString);
//   const token = user.accessToken;

//   console.log("categoryId", categoryId);
//   useEffect(() => {
//     (async () => {
//       try {
//         const response = await DocumentServices.getById(documentId);
//         console.log("response document:", response);
//         console.log("categoryId.id ::", categoryId);
//         const responseCategoryId = categoryId.find(
//           (item) => item.id === response.categoryId
//         );
//         console.log("responseCategoryId", responseCategoryId);

//         const docCategory = {
//           value: responseCategoryId.id,
//           label: responseCategoryId.name,
//         };
//         console.log("docCategory:::", docCategory);

//         formik.setFieldValue("id", response.id);
//         formik.setFieldValue("title", response.title);
//         formik.setFieldValue("cooperativeId", response.cooperativeId);
//         formik.setFieldValue("categoryId", docCategory);
//         formik.setFieldValue("file", response.file);
//         formik.setFieldValue("description", response.description);
//         formik.setFieldValue("extension", response.extension);
//         console.log("Value are set successfully");
//       } catch (error) {
//         console.log("🚀 ~ async ~ error:", error);
//       }
//     })();
//   }, [documentId]);

//   // const convertBase64ToBlob = (base64, contentType) => {
//   //   const byteCharacters = atob(base64);
//   //   const byteArrays = [];
//   //   for (let offset = 0; offset < byteCharacters.length; offset += 512) {
//   //     const slice = byteCharacters.slice(offset, offset + 512);
//   //     const byteNumbers = new Array(slice.length);
//   //     for (let i = 0; i < slice.length; i++) {
//   //       byteNumbers[i] = slice.charCodeAt(i);
//   //     }
//   //     const byteArray = new Uint8Array(byteNumbers);
//   //     byteArrays.push(byteArray);
//   //   }
//   //   return new Blob(byteArrays, { type: contentType });
//   // };

//   const formik = useFormik({
//     initialValues: {
//       id: null,
//       cooperativeId: "",
//       categoryId: "",
//       title: "",
//       file: null,
//       description: "",
//       extension: "",
//     },
//     onSubmit: async (values) => {
//       try {
//         const formData = new FormData();

//         for (const [key, value] of Object.entries(values)) {
//           if (key !== "file") {
//             formData.append(key, value);
//           }
//         }

//         // Handle the file if it exists
//         if (values.file && values.file instanceof File) {
//           formData.append("file", values.file);
//         } else {
//           const imageString = values.file;
//           let binaryString;

//           const isBase64 = (str) => {
//             try {
//               return btoa(atob(str)) === str;
//             } catch (err) {
//               return false;
//             }
//           };

//           if (isBase64(imageString.split(",")[1] || imageString)) {
//             let base64String = imageString;
//             let base64;

//             if (base64String.includes(",")) {
//               base64 = base64String.split(",")[1];
//             } else {
//               base64 = base64String;
//             }

//             binaryString = atob(base64);
//           } else {
//             binaryString = imageString;
//           }

//           const len = binaryString.length;
//           const bytes = new Uint8Array(len);
//           for (let i = 0; i < len; i++) {
//             bytes[i] = binaryString.charCodeAt(i);
//           }

//           const blob = new Blob([bytes], { type: "image/jpeg" }); // Change the type according to your image type
//           formData.append("file", blob, "image.jpg"); // 'image.jpg' can be any name you want for the file
//         }

//         await axios.put(
//           `http://api.dsccou.sebs.asia/api/documents/${documentId}`,
//           formData,
//           {
//             headers: {
//               "Content-Type": "multipart/form-data",
//               Authorization: `Bearer ${token}`,
//             },
//           }
//         );
//         toast.success("Document Updated Successfully!");
//         fetchData();
//         toggle();
//       } catch (error) {
//         console.error("Error submitting form:", error);
//       }
//     },
//   });

//   useEffect(() => {
//     (async () => {
//       try {
//         const response = await DocumentServices.getlist();
//         setCategoryId(response);
//       } catch (error) {
//         console.log("🚀 ~ async ~ error:", error);
//       }
//     })();
//   }, []);

//   const options = categoryId.map((item) => ({
//     value: item.id,
//     label: item.name,
//   }));

//   const handleChange = (selectedOption) => {
//     setSelectedOption(selectedOption);
//     formik.setFieldValue(
//       "categoryId",
//       selectedOption ? selectedOption.value : ""
//     );
//   };

//   const handleAcceptedFiles = (files) => {
//     const formattedFiles = files.map((file) => ({
//       name: file.name,
//       path: file.path,
//       preview: URL.createObjectURL(file),
//     }));
//     setSelectedFiles(formattedFiles);
//     formik.setFieldValue("file", files[0]);
//   };

//   const handleFileRemove = (index) => {
//     const files = [...selectedFiles];
//     files.splice(index, 1);
//     setSelectedFiles(files);

//     if (formik.values.file && files.length === 0) {
//       formik.setFieldValue("file", "");
//     }
//   };

//   const renderFilePreview = (file, extension) => {
//     const fileType = extension;
//     if (fileType === ".png" || fileType === ".jpg" || fileType === ".jpeg") {
//       return (
//         <img
//           src={`data:image/${fileType};base64,${file}`}
//           alt="Document"
//           // style={{ width: "100%" }}
//           height={"50"}
//         />
//       );
//     }
//     if (fileType === ".pdf") {
//       return (
//         <div className="text-center">
//           <div
//             className="profile-user position-relative d-inline-block mx-auto mb-4 cursor-pointer"
//             onClick={() => {
//               const pdfWindow = window.open("");
//               pdfWindow.document.write(
//                 `<iframe width='100%' height='100%' src='data:application/pdf;base64,${file}'></iframe>`
//               );
//             }}
//           >
//             <img
//               height={"30"}
//               src="/pdfImage.jpeg"
//               className="avatar-sm"
//               alt="user-profile"
//             />
//           </div>
//         </div>
//       );
//     }
//     return <p>Cannot preview this file type</p>;
//   };

//   return (
//     <Modal isOpen={isOpen} toggle={toggle} style={{ padding: "25px" }} centered>
//       <h4
//         onClick={toggle}
//         className="text-end pt-2 cursor-pointer"
//         style={{ paddingRight: "5px" }}
//       >
//         <i className="bx bx-x"></i>
//       </h4>
//       <h3 className="text-center fw-semi-bold fs-15">Edit Document</h3>
//       <form onSubmit={formik.handleSubmit}>
//         <Row className="p-4">
//           <Col lg={12}>
//             <Dropzone onDrop={handleAcceptedFiles}>
//               {({ getRootProps, getInputProps }) => (
//                 <div className="dropzone dz-clickable pt-4">
//                   <div
//                     className="dz-message needsclick mb-5 p-3"
//                     {...getRootProps()}
//                   >
//                     <i className=" align-item-center display-4 text-muted ri-upload-cloud-2-fill" />
//                     <h4 className="fs-15 fw-semi-bold pt-3">
//                       Drop files here or <Link to="#">click to upload.</Link>
//                     </h4>
//                     <h4 className="fs-14 text-muted ">Max Upload Size 10MB.</h4>
//                   </div>
//                 </div>
//               )}
//             </Dropzone>
//             <div className="list-unstyled mb-0" id="file-previews">
//               {selectedFiles.length > 0 ? (
//                 selectedFiles.map((f, i) => (
//                   <Card
//                     className=" mb-0  shadow-none border dz-processing dz-image-preview dz-success dz-complete"
//                     key={i + "-file"}
//                   >
//                     <div>
//                       <Row className="align-items-center">
//                         <Col className="col-auto">
//                           <img
//                             data-dz-thumbnail=""
//                             height="100"
//                             className="avatar-sm rounded bg-light"
//                             alt={f.name}
//                             src={f.preview}
//                           />
//                         </Col>
//                         <Col>
//                           <Link to="#" className="text-muted font-weight-bold">
//                             {f.name}
//                           </Link>
//                           <p className="mb-0">
//                             <strong>{f.formattedSize}</strong>
//                           </p>
//                         </Col>
//                         <Col lg={2}>
//                           <Link onClick={() => handleFileRemove(i)}>
//                             <h3>
//                               <i className="ri-delete-bin-2-line text-danger"></i>
//                             </h3>
//                           </Link>
//                         </Col>
//                       </Row>
//                     </div>
//                   </Card>
//                 ))
//               ) : formik.values.file ? (
//                 <Card className="mb-0 shadow-none border dz-processing dz-image-preview dz-success dz-complete">
//                   <div>
//                     <Row className="align-content-center">
//                       <Col xs={5} className="align-content-center">
//                         {renderFilePreview(
//                           formik.values.file,
//                           formik.values.extension
//                         )}
//                       </Col>
//                       <Col xs={5} className="align-content-center">
//                         <p className="fs-6 "> Document</p>
//                       </Col>
//                       <Col xs={2} className="align-content-center">
//                         <Link onClick={() => handleFileRemove(0)}>
//                           <h3>
//                             <i className="ri-delete-bin-2-line text-danger"></i>
//                           </h3>
//                         </Link>
//                       </Col>
//                     </Row>
//                   </div>
//                 </Card>
//               ) : null}
//             </div>
//           </Col>

//           <FormGroup>
//             <CustomInput
//               required
//               label={"Title"}
//               type={"text"}
//               handleBlur={formik.handleBlur}
//               handleChange={formik.handleChange}
//               id={"title"}
//               name={"title"}
//               placeholder={"Enter Title"}
//               value={formik.values.title}
//               error={formik.errors.title}
//               touched={formik.touched.title}
//             />
//           </FormGroup>

//           <FormGroup>
//             <Label>Category</Label>
//             <Select
//               isClearable
//               placeholder="Select Category"
//               value={selectedOption}
//               onChange={handleChange}
//               options={options}
//             />
//           </FormGroup>

//           <FormGroup>
//             <CustomInput
//               required
//               label={"Description"}
//               handleBlur={formik.handleBlur}
//               handleChange={formik.handleChange}
//               id={"description"}
//               name={"description"}
//               placeholder={"Enter Description"}
//               value={formik.values.description}
//               error={formik.errors.description}
//               touched={formik.touched.description}
//             />
//           </FormGroup>

//           <div className="d-flex pt-2 py-1 gap-1">
//             <Col lg={6} className="w-50">
//               <Button color="danger" className="w-100" onClick={() => toggle()}>
//                 Back
//               </Button>
//             </Col>
//             <Col lg={6} className="w-50">
//               <Button type="submit" color="success" className="w-100">
//                 Save & Publish
//               </Button>
//             </Col>
//           </div>
//         </Row>
//       </form>
//     </Modal>
//   );
// };

// export default EditDocument;
import React, { useEffect, useState } from "react";
import { Modal, FormGroup, Label, Button, Col, Row, Card } from "reactstrap";
import { Link } from "react-router-dom";
import Dropzone from "react-dropzone";
import toast from "react-hot-toast";
import DocumentServices from "../../../services/COOPServices/DocumentServices";
import { useFormik } from "formik";
import CustomInput from "../../../Components/Common/CustomInput/CustomInput";
import axios from "axios";
import Select from "react-select";

const EditDocument = ({ isOpen, toggle, documentId, fetchData }) => {
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [categoryId, setCategoryId] = useState([]);
  const [selectedOption, setSelectedOption] = useState(null);

  const userString = localStorage.getItem("user");
  const user = JSON.parse(userString);
  const token = user.accessToken;

  useEffect(() => {
    (async () => {
      try {
        const responseCategoryId = await DocumentServices.getlist();
        setCategoryId(responseCategoryId);
      } catch (error) {
        console.log("Error fetching categories:", error);
      }
    })();
  }, []);

  useEffect(() => {
    (async () => {
      if (categoryId.length > 0) {
        try {
          const response = await DocumentServices.getById(documentId);
          const responseCategoryId = categoryId.find(
            (item) => item.id === response.categoryId
          );

          const docCategory = {
            value: responseCategoryId.id,
            label: responseCategoryId.name,
          };

          setSelectedOption(docCategory);

          formik.setFieldValue("id", response.id);
          formik.setFieldValue("title", response.title);
          formik.setFieldValue("cooperativeId", response.cooperativeId);
          formik.setFieldValue("categoryId", docCategory);
          formik.setFieldValue("file", response.file);
          formik.setFieldValue("description", response.description);
          formik.setFieldValue("extension", response.extension);
        } catch (error) {
          console.log("Error fetching document:", error);
        }
      }
    })();
  }, [categoryId, documentId]);

  const formik = useFormik({
    initialValues: {
      id: null,
      cooperativeId: "",
      categoryId: "",
      title: "",
      file: null,
      description: "",
      extension: "",
    },
    onSubmit: async (values) => {
      console.log("values", values);
      try {
        const formData = new FormData();

        for (const [key, value] of Object.entries(values)) {
          if (key !== "file" && key !== "categoryId") {
            formData.append(key, value);
          }
        }

        if (values.file && values.file instanceof File) {
          formData.append("file", values.file);
        } else {
          const imageString = values.file;
          let binaryString;

          const isBase64 = (str) => {
            try {
              return btoa(atob(str)) === str;
            } catch (err) {
              return false;
            }
          };

          if (isBase64(imageString.split(",")[1] || imageString)) {
            let base64String = imageString;
            let base64;

            if (base64String.includes(",")) {
              base64 = base64String.split(",")[1];
            } else {
              base64 = base64String;
            }

            binaryString = atob(base64);
          } else {
            binaryString = imageString;
          }

          const len = binaryString.length;
          const bytes = new Uint8Array(len);
          for (let i = 0; i < len; i++) {
            bytes[i] = binaryString.charCodeAt(i);
          }

          const blob = new Blob([bytes], { type: "image/jpeg" });
          formData.append("file", blob, "image.jpg");

          formData.append("categoryId", values.categoryId.value);
          console.log("values.categoryId", values.categoryId.value);
        }

        await axios.put(
          `http://api.dsccou.sebs.asia/api/documents/${documentId}`,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: `Bearer ${token}`,
            },
          }
        );
        toast.success("Document Updated Successfully!");
        fetchData();
        toggle();
      } catch (error) {
        console.error("Error submitting form:", error);
      }
    },
  });

  const options = categoryId.map((item) => ({
    value: item.id,
    label: item.name,
  }));

  const handleAcceptedFiles = (files) => {
    const formattedFiles = files.map((file) => ({
      name: file.name,
      path: file.path,
      preview: URL.createObjectURL(file),
    }));
    setSelectedFiles(formattedFiles);
    formik.setFieldValue("file", files[0]);
  };

  const handleFileRemove = (index) => {
    const files = [...selectedFiles];
    files.splice(index, 1);
    setSelectedFiles(files);

    if (formik.values.file && files.length === 0) {
      formik.setFieldValue("file", "");
    }
  };

  const renderFilePreview = (file, extension) => {
    const fileType = extension;
    if (fileType === ".png" || fileType === ".jpg" || fileType === ".jpeg") {
      return (
        <img
          src={`data:image/${fileType};base64,${file}`}
          alt="Document"
          height={"50"}
        />
      );
    }
    if (fileType === ".pdf") {
      return (
        <div className="text-center">
          <div
            className="profile-user position-relative d-inline-block mx-auto mb-4 cursor-pointer"
            onClick={() => {
              const pdfWindow = window.open("");
              pdfWindow.document.write(
                `<iframe width='100%' height='100%' src='data:application/pdf;base64,${file}'></iframe>`
              );
            }}
          >
            <img
              height={"30"}
              src="/pdfImage.jpeg"
              className="avatar-sm"
              alt="user-profile"
            />
          </div>
        </div>
      );
    }
    return <p>Cannot preview this file type</p>;
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle} style={{ padding: "25px" }} centered>
      <h4
        onClick={toggle}
        className="text-end pt-2 cursor-pointer"
        style={{ paddingRight: "5px" }}
      >
        <i className="bx bx-x"></i>
      </h4>
      <h3 className="text-center fw-semi-bold fs-15">Edit Document</h3>
      <form onSubmit={formik.handleSubmit}>
        <Row className="p-4">
          <Col lg={12}>
            <Dropzone onDrop={handleAcceptedFiles}>
              {({ getRootProps, getInputProps }) => (
                <div className="dropzone dz-clickable pt-4">
                  <div
                    className="dz-message needsclick mb-5 p-3"
                    {...getRootProps()}
                  >
                    <i className=" align-item-center display-4 text-muted ri-upload-cloud-2-fill" />
                    <h4 className="fs-15 fw-semi-bold pt-3">
                      Drop files here or <Link to="#">click to upload.</Link>
                    </h4>
                    <h4 className="fs-14 text-muted ">Max Upload Size 10MB.</h4>
                  </div>
                </div>
              )}
            </Dropzone>
            <div className="list-unstyled mb-0" id="file-previews">
              {selectedFiles.length > 0 ? (
                selectedFiles.map((f, i) => (
                  <Card
                    className=" mb-0  shadow-none border dz-processing dz-image-preview dz-success dz-complete"
                    key={i + "-file"}
                  >
                    <div>
                      <Row className="align-items-center">
                        <Col className="col-auto">
                          <img
                            data-dz-thumbnail=""
                            height="100"
                            className="avatar-sm rounded bg-light"
                            alt={f.name}
                            src={f.preview}
                          />
                        </Col>
                        <Col>
                          <Link to="#" className="text-muted font-weight-bold">
                            {f.name}
                          </Link>
                          <p className="mb-0">
                            <strong>{f.formattedSize}</strong>
                          </p>
                        </Col>
                        <Col lg={2}>
                          <Link onClick={() => handleFileRemove(i)}>
                            <h3>
                              <i className="ri-delete-bin-2-line text-danger"></i>
                            </h3>
                          </Link>
                        </Col>
                      </Row>
                    </div>
                  </Card>
                ))
              ) : formik.values.file ? (
                <Card className="mb-0 shadow-none border dz-processing dz-image-preview dz-success dz-complete">
                  <div>
                    <Row className="align-content-center">
                      <Col xs={5} className="align-content-center">
                        {renderFilePreview(
                          formik.values.file,
                          formik.values.extension
                        )}
                      </Col>
                      <Col xs={5} className="align-content-center">
                        <p className="fs-6 "> Document</p>
                      </Col>
                      <Col xs={2} className="align-content-center">
                        <Link onClick={() => handleFileRemove(0)}>
                          <h3>
                            <i className="ri-delete-bin-2-line text-danger"></i>
                          </h3>
                        </Link>
                      </Col>
                    </Row>
                  </div>
                </Card>
              ) : null}
            </div>
          </Col>

          <FormGroup>
            <CustomInput
              required
              label={"Title"}
              type={"text"}
              handleBlur={formik.handleBlur}
              handleChange={formik.handleChange}
              id={"title"}
              name={"title"}
              placeholder={"Enter Title"}
              value={formik.values.title}
              error={formik.errors.title}
              touched={formik.touched.title}
            />
          </FormGroup>

          {/* <FormGroup>
            <Label>Category</Label>
            <Select
              isClearable
              placeholder="Select Category"
              value={formik.values.categoryId}
              // onChange={handleChange}
              handleChange={(value) =>
                formik.setFieldValue("categoryId", value)
              }
              options={options}
            />
          </FormGroup> */}

          <FormGroup>
            <Label htmlFor="categoryId" className="fs-12">
              Category ID
            </Label>
            <Select
              value={formik.values.categoryId}
              onChange={(option) => formik.setFieldValue("categoryId", option)}
              options={options}
              isSearchable
            />
          </FormGroup>

          <FormGroup>
            <CustomInput
              required
              label={"Description"}
              handleBlur={formik.handleBlur}
              handleChange={formik.handleChange}
              id={"description"}
              name={"description"}
              placeholder={"Enter Description"}
              value={formik.values.description}
              error={formik.errors.description}
              touched={formik.touched.description}
            />
          </FormGroup>

          <div className="d-flex pt-2 py-1 gap-1">
            <Col lg={6} className="w-50">
              <Button color="danger" className="w-100" onClick={() => toggle()}>
                Back
              </Button>
            </Col>
            <Col lg={6} className="w-50">
              <Button type="submit" color="success" className="w-100">
                Save & Publish
              </Button>
            </Col>
          </div>
        </Row>
      </form>
    </Modal>
  );
};

export default EditDocument;
// import React, { useEffect, useState } from "react";
// import { Modal, FormGroup, Label, Button, Col, Row, Card } from "reactstrap";
// import { Link } from "react-router-dom";
// import Dropzone from "react-dropzone";
// import toast from "react-hot-toast";
// import DocumentServices from "../../../services/COOPServices/DocumentServices";
// import { useFormik } from "formik";
// import CustomInput from "../../../Components/Common/CustomInput/CustomInput";
// import axios from "axios";
// import Select from "react-select";

// const EditDocument = ({ isOpen, toggle, documentId, fetchData }) => {
//   const [selectedFiles, setSelectedFiles] = useState([]);
//   const [categoryId, setCategoryId] = useState([]);
//   const [selectedOption, setSelectedOption] = useState(null);

//   const userString = localStorage.getItem("user");
//   const user = JSON.parse(userString);
//   const token = user.accessToken;

//   useEffect(() => {
//     (async () => {
//       try {
//         const responseCategoryId = await DocumentServices.getlist();
//         setCategoryId(responseCategoryId);
//       } catch (error) {
//         console.log("Error fetching categories:", error);
//       }
//     })();
//   }, []);

//   useEffect(() => {
//     (async () => {
//       if (categoryId.length > 0) {
//         try {
//           const response = await DocumentServices.getById(documentId);
//           const responseCategoryId = categoryId.find(
//             (item) => item.id === response.categoryId
//           );

//           const docCategory = {
//             value: responseCategoryId.id,
//             label: responseCategoryId.name,
//           };

//           setSelectedOption(docCategory);

//           formik.setFieldValue("id", response.id);
//           formik.setFieldValue("title", response.title);
//           formik.setFieldValue("cooperativeId", response.cooperativeId);
//           formik.setFieldValue("categoryId", docCategory);
//           formik.setFieldValue("file", response.file);
//           formik.setFieldValue("description", response.description);
//           formik.setFieldValue("extension", response.extension);
//         } catch (error) {
//           console.log("Error fetching document:", error);
//         }
//       }
//     })();
//   }, [categoryId, documentId]);

//   const formik = useFormik({
//     initialValues: {
//       id: null,
//       cooperativeId: "",
//       categoryId: "",
//       title: "",
//       file: null,
//       description: "",
//       extension: "",
//     },
//     onSubmit: async (values) => {
//       console.log("values", values);
//       try {
//         const formData = new FormData();

//         for (const [key, value] of Object.entries(values)) {
//           if (key !== "file" && key !== "categoryId") {
//             formData.append(key, value);
//           }
//         }

//         if (values.file && values.file instanceof File) {
//           formData.append("file", values.file);
//         } else {
//           const imageString = values.file;
//           let binaryString;

//           const isBase64 = (str) => {
//             try {
//               return btoa(atob(str)) === str;
//             } catch (err) {
//               return false;
//             }
//           };

//           if (isBase64(imageString.split(",")[1] || imageString)) {
//             let base64String = imageString;
//             let base64;

//             if (base64String.includes(",")) {
//               base64 = base64String.split(",")[1];
//             } else {
//               base64 = base64String;
//             }

//             binaryString = atob(base64);
//           } else {
//             binaryString = imageString;
//           }

//           const len = binaryString.length;
//           const bytes = new Uint8Array(len);
//           for (let i = 0; i < len; i++) {
//             bytes[i] = binaryString.charCodeAt(i);
//           }

//           const blob = new Blob([bytes], { type: "image/jpeg" });
//           formData.append("file", blob, "image.jpg");

//           formData.append("categoryId", values.categoryId.value);
//           console.log("values.categoryId", values.categoryId.value);
//         }

//         await axios.put(
//           `http://api.dsccou.sebs.asia/api/documents/${documentId}`,
//           formData,
//           {
//             headers: {
//               "Content-Type": "multipart/form-data",
//               Authorization: `Bearer ${token}`,
//             },
//           }
//         );
//         toast.success("Document Updated Successfully!");
//         fetchData();
//         toggle();
//       } catch (error) {
//         console.error("Error submitting form:", error);
//       }
//     },
//   });

//   const options = categoryId.map((item) => ({
//     value: item.id,
//     label: item.name,
//   }));

//   const handleAcceptedFiles = (files) => {
//     const formattedFiles = files.map((file) => ({
//       name: file.name,
//       path: file.path,
//       preview: URL.createObjectURL(file),
//     }));
//     setSelectedFiles(formattedFiles);
//     formik.setFieldValue("file", files[0]);
//   };

//   const handleFileRemove = (index) => {
//     const files = [...selectedFiles];
//     files.splice(index, 1);
//     setSelectedFiles(files);

//     if (formik.values.file && files.length === 0) {
//       formik.setFieldValue("file", "");
//     }
//   };

//   const renderFilePreview = (file, extension) => {
//     const fileType = extension;
//     if (fileType === ".png" || fileType === ".jpg" || fileType === ".jpeg") {
//       return (
//         <img
//           src={`data:image/${fileType};base64,${file}`}
//           alt="Document"
//           height={"50"}
//         />
//       );
//     }
//     if (fileType === ".pdf") {
//       return (
//         <div className="text-center">
//           <div
//             className="profile-user position-relative d-inline-block mx-auto mb-4 cursor-pointer"
//             onClick={() => {
//               const pdfWindow = window.open("");
//               pdfWindow.document.write(
//                 `<iframe width='100%' height='100%' src='data:application/pdf;base64,${file}'></iframe>`
//               );
//             }}
//           >
//             <img
//               height={"30"}
//               src="/pdfImage.jpeg"
//               className="avatar-sm"
//               alt="user-profile"
//             />
//           </div>
//         </div>
//       );
//     }
//     return <p>Cannot preview this file type</p>;
//   };

//   return (
//     <Modal isOpen={isOpen} toggle={toggle} style={{ padding: "25px" }} centered>
//       <h4
//         onClick={toggle}
//         className="text-end pt-2 cursor-pointer"
//         style={{ paddingRight: "5px" }}
//       >
//         <i className="bx bx-x"></i>
//       </h4>
//       <h3 className="text-center fw-semi-bold fs-15">Edit Document</h3>
//       <form onSubmit={formik.handleSubmit}>
//         <Row className="p-4">
//           <Col lg={12}>
//             <Dropzone onDrop={handleAcceptedFiles}>
//               {({ getRootProps, getInputProps }) => (
//                 <div className="dropzone dz-clickable pt-4">
//                   <div
//                     className="dz-message needsclick mb-5 p-3"
//                     {...getRootProps()}
//                   >
//                     <i className=" align-item-center display-4 text-muted ri-upload-cloud-2-fill" />
//                     <h4 className="fs-15 fw-semi-bold pt-3">
//                       Drop files here or <Link to="#">click to upload.</Link>
//                     </h4>
//                     <h4 className="fs-14 text-muted ">Max Upload Size 10MB.</h4>
//                   </div>
//                 </div>
//               )}
//             </Dropzone>
//             <div className="list-unstyled mb-0" id="file-previews">
//               {selectedFiles.length > 0 ? (
//                 selectedFiles.map((f, i) => (
//                   <Card
//                     className=" mb-0  shadow-none border dz-processing dz-image-preview dz-success dz-complete"
//                     key={i + "-file"}
//                   >
//                     <div>
//                       <Row className="align-items-center">
//                         <Col className="col-auto">
//                           <img
//                             data-dz-thumbnail=""
//                             height="100"
//                             className="avatar-sm rounded bg-light"
//                             alt={f.name}
//                             src={f.preview}
//                           />
//                         </Col>
//                         <Col>
//                           <Link to="#" className="text-muted font-weight-bold">
//                             {f.name}
//                           </Link>
//                           <p className="mb-0">
//                             <strong>{f.formattedSize}</strong>
//                           </p>
//                         </Col>
//                         <Col lg={2}>
//                           <Link onClick={() => handleFileRemove(i)}>
//                             <h3>
//                               <i className="ri-delete-bin-2-line text-danger"></i>
//                             </h3>
//                           </Link>
//                         </Col>
//                       </Row>
//                     </div>
//                   </Card>
//                 ))
//               ) : formik.values.file ? (
//                 <Card className="mb-0 shadow-none border dz-processing dz-image-preview dz-success dz-complete">
//                   <div>
//                     <Row className="align-content-center">
//                       <Col xs={5} className="align-content-center">
//                         {renderFilePreview(
//                           formik.values.file,
//                           formik.values.extension
//                         )}
//                       </Col>
//                       <Col xs={5} className="align-content-center">
//                         <p className="fs-6 "> Document</p>
//                       </Col>
//                       <Col xs={2}>
//                         <Link
//                           onClick={() => {
//                             formik.setFieldValue("file", "");
//                             formik.setFieldValue("extension", "");
//                           }}
//                         >
//                           <h3>
//                             <i className="ri-delete-bin-2-line text-danger"></i>
//                           </h3>
//                         </Link>
//                       </Col>
//                     </Row>
//                   </div>
//                 </Card>
//               ) : (
//                 <p>No file selected</p>
//               )}
//             </div>
//           </Col>
//         </Row>
//         <Row className="pt-3">
//           <Col md={12}>
//             <FormGroup>
//               <Label htmlFor="cooperativeId" className="fs-12">
//                 Cooperative ID
//               </Label>
//               <CustomInput
//                 type="text"
//                 name="cooperativeId"
//                 value={formik.values.cooperativeId}
//                 onChange={formik.handleChange}
//                 error={formik.errors.cooperativeId}
//               />
//             </FormGroup>
//           </Col>
//           <Col md={12}>
//             <FormGroup>
//               <Label htmlFor="categoryId" className="fs-12">
//                 Category ID
//               </Label>
//               <Select
//                 value={formik.values.categoryId}
//                 onChange={(option) =>
//                   formik.setFieldValue("categoryId", option)
//                 }
//                 options={options}
//                 isSearchable
//               />
//             </FormGroup>
//           </Col>
//           <Col md={12}>
//             <FormGroup>
//               <Label htmlFor="title" className="fs-12">
//                 Title
//               </Label>
//               <CustomInput
//                 type="text"
//                 name="title"
//                 value={formik.values.title}
//                 onChange={formik.handleChange}
//                 error={formik.errors.title}
//               />
//             </FormGroup>
//           </Col>
//           <Col md={12}>
//             <FormGroup>
//               <Label htmlFor="description" className="fs-12">
//                 Description
//               </Label>
//               <CustomInput
//                 type="textarea"
//                 name="description"
//                 value={formik.values.description}
//                 onChange={formik.handleChange}
//                 error={formik.errors.description}
//               />
//             </FormGroup>
//           </Col>
//         </Row>
//         <div className="d-flex justify-content-center">
//           <Button
//             color="primary"
//             type="submit"
//             disabled={formik.isSubmitting}
//             className="me-2"
//           >
//             Submit
//           </Button>
//           <Button color="secondary" onClick={toggle}>
//             Cancel
//           </Button>
//         </div>
//       </form>
//     </Modal>
//   );
// };

// export default EditDocument;
